import * as types from './action-types';
import templates from '../templates';
import { setTextColor, setBackground, batchUpdateCells } from '../cells';
import * as palettes from '../palettes';
import { range, isNumber, isString, flatten, pick } from 'lodash';

export function setThematic(thematic) {
  return {
    type: types.SET_THEMATIC,
    payload: thematic,
  }
}

export function setAngle(angle) {
  return {
    type: types.SET_ANGLE,
    payload: angle
  };
}

export function setAngleOffset(offset) {
  return {
    type: types.SET_ANGLE_OFFSET,
    payload: offset,
  }
}

export function setGenerations(generations) {
  return {
    type: types.SET_GENERATIONS,
    payload: generations
  };
}

export function setFont(font) {
  return {
    type: types.SET_FONT,
    payload: font
  };
}

export function setRadius(radius) {
  return {
    type: types.SET_RADIUS,
    payload: radius
  };
}

export function setMargin(margin) {
  return {
    type: types.SET_MARGIN,
    payload: margin
  };
}

export function setStrokeWidth(width) {
  return {
    type: types.SET_STROKE_WIDTH,
    payload: width
  };
}

export function setChartBackground(color) {
  return {
    type: types.SET_CHART_BACKGROUND,
    payload: color
  };
}

export function setStrokeColor(color) {
  return {
    type: types.SET_STROKE_COLOR,
    payload: color
  };
}

export function setHeading(heading) {
  return {
    type: types.SET_HEADING,
    payload: heading
  };
}

export function setSubheading(subheading) {
  return {
    type: types.SET_SUBHEADING,
    payload: subheading
  };
}

export function batchUpdateChart(changes) {
  return {
    type: types.BATCH_UPDATE_CHART,
    payload: changes
  }
}

// export function setFill(fill) {
//   return {
//     type: types.SET_FILL,
//     payload: fill
//   };
// }

export function setTextTransform(transform) {
  return {
    type: types.SET_TEXT_TRANSFORM,
    payload: transform,
  }
}

export function setTemplate(name) {
  return dispatch => {
    const template = templates[name];
    template && template.update(dispatch);
  }
}

export function setPalette(palette) {
  return dispatch => {

    if(isNumber(palette.strokeWidth)) {
      dispatch(setStrokeWidth(palette.strokeWidth));
    }
    if(isString(palette.strokeColor)) {
      dispatch(setStrokeColor(palette.strokeColor));
    }

    const cellUpdates = flatten(range(0, 10).map(generation => {
      const n = Math.pow(2, generation);
      const gColors = palette.colors[generation % palette.colors.length];
      
      return range(0, n).map(index => {
        const color = gColors[index % gColors.length];
        return {
          background: color.background,
          textColor: color.textColor,
          bandColor: color.bandColor,
          ascendancy: n + index,
        }
      })
    }))
    dispatch(batchUpdateCells(cellUpdates));
  }
}


// WEBPACK FOOTER //
// ./src/core/chart/actions.js